import * as React from "react";

const MOBILE_BREAKPOINT = 768;

// Returns `undefined` until the first effect tick determines the actual
// breakpoint, then `true`/`false` once known. Callers that mount-and-act
// (e.g. SsoCallback firing apiGetMe, MobileAutoRedirect deciding where to
// send the user) MUST check `=== undefined` and wait — otherwise the value
// flips `undefined → false → true` on mobile, causing effects to run twice
// with the wrong value on the first pass and racing on the second.
export function useIsMobile(): boolean | undefined {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
